import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RowHeightService {
  private rowHeightsSubject = new BehaviorSubject<number[]>([]);
  rowHeights$ = this.rowHeightsSubject.asObservable();

  setRowHeight(index: number, height: number) {
    const currentHeights = this.rowHeightsSubject.value;
    currentHeights[index] = height;
    this.rowHeightsSubject.next([...currentHeights]);
  }
}
